class Exceptions {
  constructor(type, subType, exception) {
    this.type = type
    this.subType = subType
    this.exception = exception
  }

  getType() {
    return this.type
  }

  setType(type) {
    this.type = type
  }

  getSubType() {
    return this.subtType
  }

  setSubType(subType) {
    this.subType = subType
  }

  getException() {
    return this.exception
  }

  setException(exception) {
    this.exception = exception
  }
}

export {
    Exceptions as default
}



// WEBPACK FOOTER //
// ./src/model/Exceptions.js